import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/material/Portal';
import apiUrl from '../Apiurl';
import stilePulsanti from '../interfaccia/stilePulsanti'
import axios from 'axios';
import {
    resolveTranslationUsername,
    translationErrorMessage,
    translationErrorProduct,
} from '../traduzioni/translationRequest';

function TraduciCiecamente({
    idProd,
    trad,
    setProductFunction,
    cambiaStato,
    nonAprireDopoTrad,
    utente
}) {

    const { user, getAccessTokenSilently } = useAuth0();
    const [inCorso, setInCorso] = useState(false);
    const [errore, setErrore] = useState("");


    let aspetto = {
        classe: "",
        testo: "",
        funzione: ""
    }

    async function traduci() {
        if (inCorso) return;
        setInCorso(true);
        setErrore("");
        try {
            const accessToken = await getAccessTokenSilently();
            const username = await resolveTranslationUsername({
                username: utente?.username,
                email: user?.email,
                accessToken,
            });
            const response = await axios.patch(
                `${apiUrl}/prodotti/translate/blindly`, // L'URL base senza l'idProd nell'URL
                {}, // Corpo vuoto
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        idDocProdotto: idProd,
                        username,
                    },
                }
            );

            cambiaStato();

            if (!nonAprireDopoTrad) {
                setProductFunction(response.data);
            }
        } catch (error) {
            const parziale = translationErrorProduct(error);
            if (parziale) {
                cambiaStato();
                if (!nonAprireDopoTrad) setProductFunction(parziale);
            }
            setErrore(translationErrorMessage(error));
        } finally {
            setInCorso(false);
        }
    }


    if (trad) {
        aspetto = {
            ...aspetto,
            classe: stilePulsanti.buttonClassesGreen,
            testo: "ok",
            funzione: () => { }
        }
    } else {
        aspetto = {
            ...aspetto,
            classe: stilePulsanti.buttonClassesOrange,
            testo: inCorso ? "..." : "trad",
            funzione: traduci
        }
    }

    return (
        <>
            <button
                className={aspetto.classe}
                onClick={aspetto.funzione}
                disabled={inCorso}
            >
                {aspetto.testo}
            </button>
            {/* Portal: le righe della DataGrid usano transform e conterrebbero il fixed. */}
            <Portal>
                <Snackbar
                    open={Boolean(errore)}
                    onClose={() => setErrore("")}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                    <Alert severity="error" onClose={() => setErrore("")}>
                        {errore}
                    </Alert>
                </Snackbar>
            </Portal>
        </>
    )
}


export default TraduciCiecamente;
